/**
 * Initializes tab functionality. Make sure Tab Button components have data-tab="###" matching the 'Id'
 *  of the corresponding of Tab Content 
 *
 * @param {NodeListOf<Element>} tabButtons - Buttons with data-tab attributes
 * @param {NodeListOf<Element>} tabContents - Tab content panels with matching IDs
 * @param {[string]} [activeClasses] - Array of strings for classes for active tab
 * @param {boolean} [useHash=true] - Whether to update URL hash on tab change
 */
export function initializeTabs(tabButtons, tabContents, activeClasses = ["border-balise-orange", "border-b-4"], useHash = true) {
    function activateTab(tabName) {
        if (!tabName) return;

        tabButtons.forEach(btn => {
            const isActive = btn.dataset.tab === tabName;
            if (isActive) {
                btn.classList.add(...activeClasses);

            }
            else {
                btn.classList.remove(...activeClasses);
            }

        });

        tabContents.forEach(content => {
            content.classList.toggle('hidden', content.id !== tabName);
        });

        if (useHash) {
            history.replaceState(null, '', `#${tabName}`);
        }
    }

    // Detect initial tab from URL (?formTab=tabName or #tabName)
    const urlParams = new URLSearchParams(window.location.search);
    const queryTab = urlParams.get('tab');
    const hashTab = window.location.hash?.replace('#', '');
    const initialTab = queryTab || hashTab;

    if (initialTab) activateTab(initialTab);

    // Add click listeners to all tab buttons
    tabButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            const tabName = btn.dataset.tab;
            activateTab(tabName);
        });
    });
}
